import { GUARANTEES } from "../mock";
import { Reveal } from "./Reveal";

export const Guarantees = () => (
  <section data-testid="guarantees-section" className="bg-[#faf7f2] py-14 sm:py-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {GUARANTEES.map((g, i) => (
          <Reveal key={g.title} delay={i * 0.1}>
            <div
              data-testid={`guarantee-badge-${i}`}
              className="flex items-start gap-4 bg-white rounded-2xl p-5 border border-slate-100 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              <span className="flex items-center justify-center w-11 h-11 rounded-full bg-[#1b7a46] text-white shrink-0">
                <g.icon className="w-5 h-5" strokeWidth={2.2} />
              </span>
              <span>
                <span className="block font-condensed font-bold uppercase tracking-tight text-[#191512] text-lg leading-tight">
                  {g.title}
                </span>
                <span className="block text-slate-500 text-sm mt-1">{g.text}</span>
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
